import React, { useEffect, useState } from "react";
// reactstrap components
import {
  Card,
  Container,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  Button,
  CustomInput,
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { connect } from "react-redux";
import Unauthorized from "views/Pages/Unauthorized";
import {
  fetchFromOptionsListing,
  fetchFromOptionsListingSuccess,
} from "../../redux/FromOptions/fromOptionsAction";
import { toast } from "react-toastify";
import { resetState } from "../../redux/common/commonAction";
import ConfirmationDeleteModal from "views/Modal/ConfirmationDeleteModal";
import { GetApiActionWithAuthorization } from "constantFunctions/apiActions";
import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import EditFromOptionModal from "views/Modal/FromOptions/EditFromOptionModal";
import AddNewFromOptionModal from "views/Modal/FromOptions/AddNewFromOptionModal";

function FromOptions(props) {
  const [unauthorized, setUnauthorized] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [confirm, setConfirm] = useState(false);
  const [delId, setDelId] = useState("");
  useEffect(() => {
    props.fetchFromOptionsListing();
  }, []);

  if (props.from.error && !unauthorized) {
    if (props.from.error.status === 403) {
      setUnauthorized(true);
    } else if (props.from.error.status === 440) {
      props.resetState();
      toast.error(props.from.error.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      props.history.push("/auth/login");
    }
  }

  const toggleAdd = (e) => {
    setAddModal(!addModal);
  };

  const toggleEdit = (id = "", name = "") => {
    setEditData({ id, name });
    setEditModal(!editModal);
  };

  const toggleConfirm = (id = "") => {
    setDelId(id);
    setConfirm(!confirm);
  };

  const confirmed = (e) => {
    GetApiActionWithAuthorization("common/delete-from-option/" + delId)
      .then((res) => {
        props.addUpdatedData(res.data);
        //toast.success(res.message, { position: toast.POSITION.TOP_CENTER });
        setConfirm(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.status === 403) {
          setUnauthorized(true);
        } else if (err.status === 440) {
          props.resetState();
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };

  const changeOrder = (decrease, id, order) => {
    let body = { decrease, id, order,type:"ads_from_options" };
    PostApiWithAuthorizationAction("common/change-order", body)
      .then((res) => {
        props.addUpdatedData(res.data);
      })
      .catch((err) => {
        if (err.status === 403) {
          setUnauthorized(true);
        } else if (err.status === 440) {
          props.resetState();
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };

  const renderTicketsTableData = (e) => {
    return props.from.allOptions.map((clerk, i) => {
      return (
        <tr key={i}>
          <td>
            [
            <span
            id={"update-option"+i}
              className="delete-item"
              onClick={(e) => {
                toggleEdit(clerk.id, clerk.name);
              }}
            >
              Edit
            </span>
            ] [
            <span
            id={"delete-option"+i}
            className="delete-item"
              onClick={(e) => toggleConfirm(clerk.id)}
            >
              Delete
            </span>
            ]{" "}
          </td>
          <td>{clerk.name}</td>
          <td className="display-order">
            <Button
            className="px-2 py-2"
              onClick={(e) => {
                if (i !== 0) {
                  changeOrder(true, clerk.id, clerk.displayOrder);
                }
              }}
            >
              <i className="fas fa-arrow-up"></i> Up
            </Button>
            <Button
            className="px-2 py-2"
            onClick={(e) => {
                if (i !== props.from.allOptions.length - 1) {
                  changeOrder(false, clerk.id, clerk.displayOrder);
                }
              }}
            >
              {" "}
              <i className="fas fa-arrow-down"></i> Down
            </Button>
          </td>
          {/* <td>
            <span
              className="delete-item"
              onClick={(e) => {
                toggleEdit(buyer.id, buyer.name);
              }}
            >
              Edit
            </span>
          </td> */}
        </tr>
      );
    });
  };

  return unauthorized ? (
    <Unauthorized />
  ) : (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--9 main-content" fluid>
        <Card className="card-height shadow">
          <CardHeader>
            <div className="text-center">
              <h1>From Options</h1>
            </div>
          </CardHeader>
          <CardBody>
            <Row className="mb-3">
              <Col md="6" className="search-left-btn">
                <Button id="add-new" color="primary" onClick={toggleAdd}>
                  Add New+
                </Button>
              </Col>
            </Row>
            <Table className="ticket-table table-listing" responsive bordered>
              <thead className="thead-light">
                <tr>
                  <th scope="col">Action</th>
                  <th scope="col">Name</th>
                  <th scope="col">Order</th>
                </tr>
              </thead>
              <tbody>{renderTicketsTableData()}</tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
      {addModal && (
        <AddNewFromOptionModal {...props} show={addModal} toggle={toggleAdd} />
      )}
      {editModal && (
        <EditFromOptionModal
          {...props}
          show={editModal}
          editData={editData}
          toggle={toggleEdit}
        />
      )}
      {confirm && (
        <ConfirmationDeleteModal
          show={confirm}
          toggle={toggleConfirm}
          confirmed={confirmed}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    from: state.fromOptionsReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchFromOptionsListing: () => dispatch(fetchFromOptionsListing()),
    addUpdatedData: (data) => dispatch(fetchFromOptionsListingSuccess(data)),
    resetState: () => dispatch(resetState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FromOptions);
